exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form[data-v-150ab628]{display:flex;align-content:flex-end}.form label[data-v-150ab628]{margin-right:1rem}", ""]);

// exports
